import { render } from "./DepartmentDetail.vue?vue&type=template&id=482f298b"
import script from "./DepartmentDetail.vue?vue&type=script&lang=js"
export * from "./DepartmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__